<h1 mat-dialog-title>Upload Results</h1>

<div mat-dialog-content>
  <div class="success-section mb-3">
    <p class="text-success mb-2">
      <mat-icon class="align-middle me-2">check_circle</mat-icon>
      <strong>Successfully imported {{ successCount }} {{ successCount === 1 ? 'company' : 'companies' }}</strong>
    </p>
  </div>

  <div class="warning-section" *ngIf="notFound && notFound.length > 0">
    <p class="text-warning mb-2">
      <mat-icon class="align-middle me-2">warning</mat-icon>
      <strong>{{ notFound.length }} ISIN{{ notFound.length === 1 ? '' : 's' }} not found in database:</strong>
    </p>
    <div class="not-found-list">
      <ul class="list-unstyled ps-4">
        <li *ngFor="let isin of notFound" class="mb-1">
          <code>{{ isin }}</code>
        </li>
      </ul>
    </div>
    <p class="text-muted mt-2">
      <small>These ISINs were not found in our database and have been skipped.</small>
    </p>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">
    Cancel
  </button>
  <button mat-flat-button color="primary" (click)="onContinue()">
    Continue with imported companies
  </button>
</div>
